module.exports = __webpack_public_path__ + "static/media/3655E8_2_0.abc90bf8.ttf";